import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { httpClient } from '@lib/httpClient';
import {
  IOrderRequestPayload,
  IOrderRequestResponse,
  OrderRequestState
} from './types';

export const useOrderRequestStore = create<OrderRequestState>()(
  devtools((_set, _get) => ({
    submitOrder: async (payload: IOrderRequestPayload) => {
      try {
        const endpoint = '/api/encomende-seu-imovel';
        const { data } = await httpClient.post<IOrderRequestResponse>(
          endpoint,
          payload
        );
        return data;
      } catch {
        return null;
      }
    }
  }))
);
